export async function withdrawSpaceFunds(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { spaceId, recipient, signer, currencyAddress } = fnArgs;
    const space = spaceDapp?.getSpace(spaceId);
    if (!space) {
        throw new Error(`Space with spaceId "${spaceId}" is not found.`);
    }
    const callData = space.Treasury.encodeFunctionData('withdraw', [currencyAddress, recipient]);
    return smartAccount.sendUserOp({
        toAddress: space.Membership.address,
        callData,
        functionHashForPaymasterProxy: 'withdraw',
        signer,
        spaceId: undefined,
    });
}
